function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { Markdown } from "./Markdown";
import { Text } from "./Text";
import { View } from "./View";
import { useTheme } from "../styles";
function Cell(props) {
    var theme = useTheme().theme;
    return /*#__PURE__*/ _jsx(View, {
        flex: 1,
        style: [
            {
                flexBasis: '100%',
                flexShrink: 1,
                padding: 10,
                paddingVertical: 16,
                backgroundColor: props.header ? '#EBF1ED' : undefined,
                borderLeftWidth: props.isFirstColumn ? 0 : 2,
                borderTopWidth: props.isFirstRow ? 0 : 2,
                borderColor: theme.color.accent100,
                alignItems: 'center',
                justifyContent: 'center'
            },
            props.style
        ],
        children: props.markdown ? /*#__PURE__*/ _jsx(Markdown, {
            fontFamily: "OpenSansSemiBold",
            children: props.node
        }) : typeof props.node === 'string' ? /*#__PURE__*/ _jsx(Text, {
            text: props.node,
            weight: props.isFirstRow ? 'bold' : 'semibold',
            size: 14
        }) : props.node
    });
}
/**
 * This function renders a table for a chat interface, structuring data into
 * rows and cells.
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-65}
 */ export function ChatTable(param) {
    var alignItems = param.alignItems, flexBasis = param.flexBasis, markdown = param.markdown, data = param.data, borderColor = param.borderColor, borderWidth = param.borderWidth, headerStyle = param.headerStyle, rowTestIDPrefix = param.rowTestIDPrefix;
    return /*#__PURE__*/ _jsx(View, {
        style: {
            flexGrow: 1,
            alignSelf: 'stretch'
        },
        children: data.map(function(row, j) {
            return /*#__PURE__*/ _jsx(View, {
                row: true,
                flex: 1,
                style: {
                    alignItems: 'stretch'
                },
                testID: "".concat(rowTestIDPrefix !== null && rowTestIDPrefix !== void 0 ? rowTestIDPrefix : 'ChatTable_row', "_").concat(j),
                children: row.map(function(nodeOrConfigNode, i) {
                    var node = nodeOrConfigNode !== null && (typeof nodeOrConfigNode === "undefined" ? "undefined" : _type_of(nodeOrConfigNode)) === 'object' && 'config' in nodeOrConfigNode ? nodeOrConfigNode.node : nodeOrConfigNode;
                    var config = nodeOrConfigNode !== null && (typeof nodeOrConfigNode === "undefined" ? "undefined" : _type_of(nodeOrConfigNode)) === 'object' && 'config' in nodeOrConfigNode ? nodeOrConfigNode.config : {};
                    var _node_key;
                    return /*#__PURE__*/ _jsx(Cell, {
                        markdown: markdown,
                        node: node,
                        header: j === 0,
                        isFirstColumn: i === 0,
                        style: [
                            {
                                flexBasis: flexBasis ? flexBasis[i] : i === row.length - 1 ? '170%' : '100%',
                                borderTopRightRadius: j === 0 && i === row.length - 1 ? 14 : 0,
                                borderTopLeftRadius: j === 0 && i === 0 ? 14 : 0
                            },
                            j === 0 ? headerStyle : null,
                            (alignItems === null || alignItems === void 0 ? void 0 : alignItems[i]) ? {
                                alignItems: alignItems[i]
                            } : null,
                            borderColor ? {
                                borderColor: borderColor
                            } : null,
                            borderWidth ? {
                                borderLeftWidth: i === 0 ? 0 : borderWidth,
                                borderTopWidth: j === 0 ? 0 : borderWidth
                            } : null,
                            config.style
                        ],
                        isFirstRow: j === 0
                    }, typeof node === 'string' ? node || i : (_node_key = node.key) !== null && _node_key !== void 0 ? _node_key : i);
                })
            }, j);
        })
    });
}
